import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WorkflowModule } from './workflow/workflows.module';
import { HomeModule } from './home/home.module';
import { NavBarModule } from './nav-bar/nav-bar.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { HttpClientModule } from '@angular/common/http';
import { AdministratorProfileModule } from './administrator/administrator-profile.module';
import { TerminoscondicionesModule } from './terminos-condiciones/terminos-condiciones.module';
import { enviroment } from 'src/environments/environment';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SolicitudCompanyLoanModule } from './solicitud-company-loan/solicitud-company-loan.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeEsCl from '@angular/common/locales/es-CL';

// Registrar los datos de localización para es-CL
registerLocaleData(localeEsCl, 'es-CL');

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TerminoscondicionesModule,
    SolicitudCompanyLoanModule,
    NgbModule,
    HomeModule,
    NavBarModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    DragDropModule,
    WorkflowModule,
    CommonModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [enviroment.url],
        sendAccessToken: true,
      },
    }),
    AdministratorProfileModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-CL' } // Proporcionar la localización
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
